// extracted by mini-css-extract-plugin
export default {"image":"Gallery_image__D1RdD","skeleton":"Gallery_skeleton__1PKXB","scale":"Gallery_scale__YzonJ"};